import React from 'react'

const Contact = ({
  preText,
  postText,
  email = 'contactus@sheddaquarium.org',
  phone = '312-939-2438'
}) => (
  <p
    role="status"
    className="font-bold text-16"
  >
    {preText ? `${preText}` : ''}
    {email || phone ? ' Please contact us at ' : ''}
    {email ? <a href={`mailto:${email}`}>{email}</a> : ''}
    {email && phone ? ' or ' : ''}
    {phone ? <a href={`tel:${phone.replace('-', '')}`}>{phone}</a> : ''}
    {postText ? ` ${postText}` : email || phone ? '.' : ''}
  </p>
)

export default Contact
